import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=1d454e6d&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=1d454e6d&prod&scoped=true&lang=scss"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=1d454e6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d454e6d",
  null
  
)

export default component.exports